import Config from "Config/Config";
import { Reducer } from "redux";
import { ActionTypes, AuthenticationActions, IAuthenticationState } from "./AuthenticationActionTypes";

export const initialState: IAuthenticationState = {
    isAuthorized: undefined,
    login: undefined
};

const reducer: Reducer<IAuthenticationState> = (state: IAuthenticationState = initialState, action: AuthenticationActions) => {
    switch (action.type) {
        case ActionTypes.UPDATE_TOKEN:
            sessionStorage.setItem(Config.STORAGE_TOKEN, JSON.stringify(action.data));
            return { ...state, isAuthorized: true, login: action.data };
        case ActionTypes.VERIFY_VALIDATION:
            return { ...state, verifyValidation: action.data };
        case ActionTypes.LOGOUT:
            sessionStorage.removeItem(Config.STORAGE_TOKEN);
            return initialState;
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/Store/Authentication/AuthenticationReducer.ts